/*
  Chaos Zero Nightmare Catalog - Full UI Integration
  - Follows lc01/zzz01 pattern with Vercel proxy
  - API endpoint: http://43.133.38.4/index/index/username_list.html?item_id=321&ascription_id=0&page=1
  - Uses Vercel proxy for CORS and HTTP→HTTPS image conversion
  - Server filter: Extract from 'district' field (全球 = Global, 亚服/亚洲 = Asia)
  - Response shape: { pages, data: [ { role_img: [ { id, name, code, img, ... }, ... ] } ] }
*/
(function () {
  /* ====== API Sources Declaration ====== */
  // This declares all API sources used by this catalog
  // Used by Shopify admin to generate toggle controls
  const API_SOURCES = {
    'chushi': { name: 'Chushi (Official)', enabled: true, priority: 1 },
    'czn01': { name: 'CZN01 (Third-party)', enabled: true, priority: 2 }
  };

  const escapeHtml = s => String(s || '').replace(/[&<>"']|'/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

  // Chushi API endpoints (game_id=8 for Chaos Zero Nightmare)
  const CHUSHI_API_BASE = 'https://www.chushi.shop/gamefun/api/game/frontend';
  const GAME_ID = 8;

  // CZN01 API endpoints (via Vercel proxy)
  const CZN01_ALL_CHARS_API = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/czn01-proxy?action=list';
  const CZN01_DECK_API = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/czn01-proxy';

  let selected = {};
  let characterList = [];

  // Store catalog mappings for search
  window._czn01Catalog = [];
  window._chushiCatalog = [];

  // Settings & Translations Initialization
  let cznSettings = { translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {} };
  try {
    const el = document.getElementById('catalog-czn-settings');
    if (el) cznSettings = JSON.parse(el.textContent);
  } catch (e) {
    console.error('[CZN] Failed to parse settings:', e);
    cznSettings = { translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {} };
  }

  // console.log('[CZN] Raw settings from Liquid:', cznSettings);
  // console.log('[CZN] API toggles received:', cznSettings.api_toggles);
  // console.log('[CZN] API priority received:', cznSettings.api_priority);

  // Override API_SOURCES enabled state from admin settings
  if (cznSettings.api_toggles) {
    Object.keys(API_SOURCES).forEach(apiId => {
      const oldState = API_SOURCES[apiId].enabled;
      if (cznSettings.api_toggles.hasOwnProperty(apiId)) {
        API_SOURCES[apiId].enabled = cznSettings.api_toggles[apiId] === true;
        // console.log(`[CZN] API '${apiId}': ${oldState} → ${API_SOURCES[apiId].enabled} (admin setting: ${cznSettings.api_toggles[apiId]})`);
      }
    });
  }

  // Override API_SOURCES priority from admin settings
  if (cznSettings.api_priority) {
    Object.keys(API_SOURCES).forEach(apiId => {
      const oldPriority = API_SOURCES[apiId].priority;
      if (cznSettings.api_priority.hasOwnProperty(apiId)) {
        const newPriority = parseInt(cznSettings.api_priority[apiId]);
        if (!isNaN(newPriority) && newPriority > 0) {
          API_SOURCES[apiId].priority = newPriority;
          // console.log(`[CZN] API '${apiId}' priority: ${oldPriority} → ${newPriority} (admin setting: ${cznSettings.api_priority[apiId]})`);
        }
      }
    });
  }

  // console.log('[CZN] ═══════════════════════════════════════════');
  // console.log('[CZN] FINAL API SOURCES STATUS:');
  Object.entries(API_SOURCES)
    .sort(([, a], [, b]) => a.priority - b.priority)
    .forEach(([id, api]) => {
      // console.log(`[CZN]   [Priority ${api.priority}] ${id}: ${api.enabled ? '✅ ENABLED' : '❌ DISABLED'} (${api.name})`);
    });
  // console.log('[CZN] ═══════════════════════════════════════════');

  // Check if at least one API is enabled
  const enableApiCalls = Object.values(API_SOURCES).some(api => api.enabled);

  let nameTranslations = {}, nameTranslationsMap = {};
  try {
    nameTranslations = JSON.parse(cznSettings.translations_json || '{}');
    Object.entries(nameTranslations).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) nameTranslationsMap[k] = val; });
    });
  } catch (e) {
    console.warn('[CZN] Failed to parse translations:', e);
    nameTranslations = {};
    nameTranslationsMap = {};
  }

  let customImages = {}, customImagesMap = {};
  try {
    customImages = JSON.parse(cznSettings.images_json || '{}');
    Object.entries(customImages).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) customImagesMap[k] = val; });
    });
  } catch (e) {
    console.warn('[CZN] Failed to parse custom images:', e);
    customImages = {};
    customImagesMap = {};
  }

  // Translation helper function
  const translateName = name => nameTranslationsMap[name] || name;

  // Custom image helper function
  const getCustomImage = name => customImagesMap[name] || null;

  // Server translation helper
  const translateServer = (district) => {
    const serverMap = {
      '全球': 'Global',
      '亚服': 'Asia',
      '亚洲': 'Asia'
    };
    return serverMap[district] || district;
  };

  // ID obfuscation logic (same as chushi-app.js)
  function privateToPublicID(privateID) {
    if (!privateID) return '';
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const randomChars = len => Array.from({ length: len }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    const reversed = String(privateID).split('').reverse().join('');
    // Swap neighboring pairs in reversed
    let arr = reversed.split('');
    for (let i = 0; i + 1 < arr.length; i += 2) {
      [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]];
    }
    const swapped = arr.join('');
    return randomChars(2) + swapped + randomChars(2);
  }

  // Sort characters: regular characters first, then weapons (with "武器" or similar prefix)
  const sortCharacters = (chars) => {
    return chars.sort((a, b) => {
      const aIsWeapon = a.name.includes('武器') || a.name.includes('装备');
      const bIsWeapon = b.name.includes('武器') || b.name.includes('装备');

      // If one is weapon and the other isn't, non-weapon comes first
      if (aIsWeapon && !bIsWeapon) return 1;
      if (!aIsWeapon && bIsWeapon) return -1;

      // If both are same type, maintain original order
      return 0;
    });
  };

  // Pagination state
  let allFilteredAccounts = []; // All accounts currently displayed
  let currentPage = 0; // Last page we fetched
  let totalPages = 0; // Total pages available from API
  let currentSearchParams = null; // Store search params for continuation
  let currentSelectedServer = ''; // Store selected server for continuation
  let isLoadingMore = false; // Prevent multiple simultaneous loads
  const ACCOUNTS_PER_BATCH = 5; // Show 5 accounts per batch

  function updateSelectedUI() {
    const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    const selectedCountEl = document.querySelector("#selectedCount");
    if (selectedCountEl) selectedCountEl.textContent = totalCount;
  }

  // Scroll to results section for better UX
  const scrollToResults = () => document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  function updateThumbDisplay(thumb, id) {
    const count = selected[id]?.count || 0;
    const existingBadge = thumb.querySelector('.count-badge');
    if (count > 0) {
      thumb.classList.add('selected');
      if (existingBadge) {
        existingBadge.textContent = count;
      } else {
        const badge = document.createElement('div');
        badge.className = 'count-badge';
        badge.textContent = count;
        thumb.querySelector('.thumb-img-container').appendChild(badge);
      }
    } else {
      thumb.classList.remove('selected');
      if (existingBadge) existingBadge.remove();
    }
  }

  function clearSelection() {
    selected = {};
    document.querySelectorAll('.thumb').forEach(thumb => {
      thumb.classList.remove('selected');
      const badge = thumb.querySelector('.count-badge');
      if (badge) badge.remove();
    });
    updateSelectedUI();
  }

  function showToast(message, duration = 3000) {
    const toast = document.querySelector("#toast");
    if (!toast) return;

    // Update toast message if provided
    if (message) {
      const toastText = toast.querySelector('.toast-content span');
      if (toastText) toastText.textContent = message;
    }

    toast.classList.remove('hidden');
    toast.offsetHeight;
    toast.classList.add('show');

    if (duration > 0) {
      setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.classList.add('hidden'), 300); }, duration);
    }
  }

  function hideToast() {
    const toast = document.querySelector("#toast");
    if (!toast) return;
    toast.classList.remove('show');
    setTimeout(() => toast.classList.add('hidden'), 300);
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => showToast('ID copied! Please share this with customer service to get price quotation.')).catch(() => fallbackCopy(text));
    } else fallbackCopy(text);
  }

  function fallbackCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); showToast('ID copied! Please share this with customer service to get price quotation.'); } catch (e) { console.error('Copy failed:', e); }
    document.body.removeChild(ta);
  }

  function renderFilterUI() {
    const container = document.querySelector("#filters");
    if (!container) return;
    container.innerHTML = '';
    if (!characterList.length) {
      container.innerHTML = '<div class="no-data">No character data.</div>';
      return;
    }
    characterList.forEach(char => {
      const thumb = document.createElement('div');
      thumb.className = 'thumb';

      // Store both CZN01 and Chushi IDs for dual API querying
      thumb.dataset.czn01Code = char.czn01Code || '';
      thumb.dataset.chushiId = char.chushiId || '';

      // Use composite key for selection (prefer czn01Code, fallback to chushiId)
      const compositeId = char.czn01Code || char.chushiId || char.id;
      thumb.dataset.rid = compositeId;

      // Apply translation and custom image
      const displayName = translateName(char.name);
      const customImg = getCustomImage(char.name);
      const displayImg = customImg || char.img;

      thumb.innerHTML = `
        <div class="thumb-img-container">
          <img alt="${escapeHtml(displayName)}" src="${escapeHtml(displayImg)}" loading="lazy"/>
        </div>
        <div class="label">${escapeHtml(displayName)}</div>
      `;
      thumb.onclick = () => {
        const id = thumb.dataset.rid;
        if (selected[id]) {
          selected[id].count++;
        } else {
          selected[id] = {
            count: 1,
            czn01Code: thumb.dataset.czn01Code,
            chushiId: thumb.dataset.chushiId,
            name: displayName,
            img: displayImg,
            originalName: char.name
          };
        }
        updateThumbDisplay(thumb, id);
        updateSelectedUI();
      };
      container.appendChild(thumb);
    });
    updateSelectedUI();
  }

  function loadResources() {
    // Show API status banner if all APIs disabled
    const disabledApis = Object.entries(API_SOURCES).filter(([id, api]) => !api.enabled).map(([id, api]) => api.name);
    if (disabledApis.length === Object.keys(API_SOURCES).length) {
      // console.log('[CZN] All APIs are disabled - showing warning banner');
      const searchSection = document.querySelector("#czn01");
      if (searchSection) {
        const banner = document.createElement('div');
        banner.style.cssText = 'background: #fef3c7; border: 2px solid #f59e0b; border-radius: 8px; padding: 12px 16px; margin: 16px 0; color: #92400e; font-weight: 500; text-align: center;';
        banner.innerHTML = `⚠️ API calls are currently disabled. Search functionality is temporarily unavailable. Please contact Gachamacha support for assistance.`;
        searchSection.insertBefore(banner, searchSection.firstChild);
      }
    }

    // Build promises array based on enabled APIs
    const resourcePromises = [];

    if (API_SOURCES.chushi.enabled) {
      // console.log('[CZN] Loading Chushi resources');
      resourcePromises.push(fetch(`${CHUSHI_API_BASE}/resource/get?game_id=${GAME_ID}`).then(r => r.json()));
    } else {
      // console.log('[CZN] Skipping Chushi resources (disabled)');
      resourcePromises.push(Promise.resolve({ data: { items: [] } }));
    }

    if (API_SOURCES.czn01.enabled) {
      // console.log('[CZN] Loading CZN01 resources');
      resourcePromises.push(fetch(CZN01_ALL_CHARS_API).then(r => r.json()));
    } else {
      // console.log('[CZN] Skipping CZN01 resources (disabled)');
      resourcePromises.push(Promise.resolve({ characters: [] }));
    }

    Promise.all(resourcePromises)
      .then(([chushiPayload, czn01Payload]) => {
        let chushiItems = chushiPayload?.data?.items || [];
        let czn01Items = czn01Payload?.characters || [];

        // console.log(`[CZN] Loaded ${chushiItems.length} characters from Chushi API`);
        // console.log(`[CZN] Loaded ${czn01Items.length} characters from CZN01 API`);

        // Store for search mapping
        window._chushiCatalog = chushiItems;
        window._czn01Catalog = czn01Items;

        // Merge by translated name (deduplication)
        const merged = {};

        // Add Chushi items
        chushiItems.forEach(it => {
          const translated = translateName(it.name) || `ID ${it.id}`;
          merged[translated] = {
            name: it.name,
            chushiId: it.id,
            img: it.img_url
          };
        });

        // Add CZN01 items (merge if already exists)
        czn01Items.forEach(it => {
          const translated = translateName(it.name) || it.name;
          if (!merged[translated]) {
            merged[translated] = {
              name: it.name,
              czn01Code: it.code,
              img: it.img
            };
          } else {
            // Character exists in both catalogs - merge IDs
            merged[translated].czn01Code = it.code;
            // Prefer CZN01 image if Chushi image is missing
            if (!merged[translated].img && it.img) {
              merged[translated].img = it.img;
            }
          }
        });

        characterList = Object.values(merged).map(item => ({
          ...item,
          id: item.czn01Code || item.chushiId // Composite ID for tracking
        }));

        // console.log(`[CZN] Merged ${characterList.length} unique characters (deduplicated by translated name)`);

        // Sort: Characters first, then weapons
        characterList = sortCharacters(characterList);
        const weaponCount = characterList.filter(c => c.name.includes('武器') || c.name.includes('装备')).length;
        // console.log(`[CZN] Sorted: ${characterList.length - weaponCount} characters, ${weaponCount} weapons`);

        renderFilterUI();
      })
      .catch(err => {
        console.error("CZN filter load failed:", err);
        const container = document.querySelector("#filters");
        if (container) container.innerHTML = '<div class="no-data">Failed to load character list.</div>';
      });
  }

  // Fetch pages incrementally until we have enough filtered results
  async function fetchNextBatch(baseParams, selectedCodes, selectedServer, targetCount, isLoadMore = false) {
    const filteredAccounts = [];
    let lastPage = currentPage;
    let totalPagesAvailable = 0;
    let checkedPages = 0;
    const maxPagesToCheck = 10; // Safety limit to prevent infinite loops
    const resultsEl = document.querySelector("#results");

    while (filteredAccounts.length < targetCount && checkedPages < maxPagesToCheck) {
      lastPage++;
      checkedPages++;

      // Update loading message with progress
      if (resultsEl) {
        if (isLoadMore) {
          // For load more, append loading indicator at the bottom
          let loadingDiv = resultsEl.querySelector('#loadMoreLoading');
          if (!loadingDiv) {
            loadingDiv = document.createElement('div');
            loadingDiv.id = 'loadMoreLoading';
            loadingDiv.className = 'loading';
            resultsEl.appendChild(loadingDiv);
          }
          loadingDiv.textContent = `🔍 Searching page ${lastPage}... Found ${filteredAccounts.length} matching account(s) so far`;
        } else {
          // For initial search, replace entire content
          resultsEl.innerHTML = `<div class="loading">🔍 Searching page ${lastPage}... Found ${filteredAccounts.length} matching account(s) so far</div>`;
        }
      }

      const pageParams = new URLSearchParams(baseParams);
      pageParams.set('page', lastPage.toString());
      const pageUrl = `${CZN01_DECK_API}?${pageParams.toString()}`;

      try {
        const response = await fetch(pageUrl);

        if (!response.ok) {
          console.error(`Page ${lastPage} HTTP error: ${response.status} ${response.statusText}`);

          // Handle timeout errors specifically
          if (response.status === 504) {
            const errorData = await response.json().catch(() => ({ error: 'Gateway Timeout' }));
            console.error('Timeout error:', errorData);
            throw new Error('TIMEOUT: ' + (errorData.error || 'The game server is not responding'));
          }

          const errorText = await response.text();
          console.error('Error response:', errorText);
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        // Store total pages from first response
        if (totalPagesAvailable === 0) {
          totalPagesAvailable = parseInt(data.pages) || 1;
        }

        const pageAccounts = data.data || [];

        // Filter accounts that have ALL selected characters AND match selected server
        const matchingAccounts = pageAccounts.filter(account => {
          const accountCodes = account.user_role || [];
          const hasAllChars = selectedCodes.every(code => accountCodes.includes(code));

          // Check server filter (if a server is selected)
          const matchesServer = !selectedServer || account.district === selectedServer;

          return hasAllChars && matchesServer;
        });

        filteredAccounts.push(...matchingAccounts);

        // Stop if we've reached the last page
        if (lastPage >= totalPagesAvailable) {
          break;
        }

        // Stop if we have enough results
        if (filteredAccounts.length >= targetCount) {
          break;
        }
      } catch (err) {
        console.error(`Error fetching page ${lastPage}:`, err);

        // If it's a timeout, throw it up to be handled by the caller
        if (err.message && err.message.includes('TIMEOUT')) {
          throw err;
        }

        // For other errors, stop pagination but don't throw
        break;
      }
    }

    return {
      filteredAccounts: filteredAccounts,
      lastPage: lastPage,
      totalPages: totalPagesAvailable,
      hasMore: lastPage < totalPagesAvailable
    };
  }

  async function performSearch() {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    if (!Object.keys(selected).length) {
      resultsEl.innerHTML = '<div class="no-data">No selection.</div>';
      return;
    }

    // Check if API calls are disabled
    if (!enableApiCalls) {
      // console.log('[CZN] All APIs are disabled via admin settings');
      resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      showToast('⚠️ API calls are currently disabled', 3000);
      return;
    }

    // Show toast notification
    showToast('🔍 Searching for matching accounts... Please wait.', 0); // 0 = don't auto-hide

    resultsEl.innerHTML = '<div class="loading">🔍 Searching for matching accounts...</div>';
    scrollToResults();

    // Get selected server
    const serverSelect = document.querySelector('#serverSelect');
    const selectedServer = serverSelect ? serverSelect.value : '';

    // console.log('[CZN] ═══════════════════════════════════════════');
    // console.log('[CZN] SEARCH: Building API parameters...');
    // console.log(`[CZN] Selected server: ${selectedServer || 'All Servers'}`);

    // Build Chushi API parameters (JSON groups format)
    const chushiGroups = {};
    Object.values(selected).forEach(sel => {
      if (sel.chushiId) {
        chushiGroups[sel.chushiId] = (chushiGroups[sel.chushiId] || 0) + sel.count;
      }
    });

    // Note: Chushi API for CZN doesn't have server filter based on payload analysis
    // All accounts are Global server
    const chushiUrl = `${CHUSHI_API_BASE}/resource/search?game_id=${GAME_ID}&code=&description=&groups=${encodeURIComponent(JSON.stringify(chushiGroups))}`;

    // Build CZN01 API parameters (role[CODE]=count format)
    const czn01BaseParams = new URLSearchParams({
      item_id: '321',
      ascription_id: '0',
      District: selectedServer
    });

    // Add selected characters as role[CODE]=count for CZN01
    const czn01SelectedCodes = [];
    Object.values(selected).forEach(sel => {
      if (sel.czn01Code) {
        czn01SelectedCodes.push(sel.czn01Code);
        czn01BaseParams.append(`role[${sel.czn01Code}]`, sel.count);
      }
    });

    // console.log('[CZN] Chushi groups:', chushiGroups);
    // console.log('[CZN] CZN01 codes:', czn01SelectedCodes);
    // console.log('[CZN] Chushi URL:', chushiUrl);

    try {
      // Reset pagination state
      currentPage = 0;
      allFilteredAccounts = [];
      currentSearchParams = czn01BaseParams;
      currentSelectedServer = selectedServer;

      // Query both APIs based on enabled state
      // console.log('[CZN] ═══════════════════════════════════════════');
      // console.log('[CZN] SEARCH: Querying APIs...');

      let chushiPromise;
      if (API_SOURCES.chushi.enabled && Object.keys(chushiGroups).length > 0) {
        // console.log('[CZN] ✅ Querying Chushi API');
        chushiPromise = fetch(chushiUrl).then(r => r.json());
      } else {
        // console.log('[CZN] ❌ Skipping Chushi API (disabled or no matching characters)');
        chushiPromise = Promise.resolve({ data: { items: [] } });
      }

      let czn01Promise;
      if (API_SOURCES.czn01.enabled && czn01SelectedCodes.length > 0) {
        // console.log('[CZN] ✅ Querying CZN01 API (with pagination)');
        // CZN01 uses pagination - fetch first batch
        czn01Promise = fetchNextBatch(czn01BaseParams, czn01SelectedCodes, selectedServer, ACCOUNTS_PER_BATCH);
      } else {
        // console.log('[CZN] ❌ Skipping CZN01 API (disabled or no matching characters)');
        czn01Promise = Promise.resolve({ filteredAccounts: [], lastPage: 0, totalPages: 0, hasMore: false });
      }

      // console.log('[CZN] ═══════════════════════════════════════════');

      // Wait for both APIs to complete
      const [chushiData, czn01Result] = await Promise.all([chushiPromise, czn01Promise]);

      // Process results
      const chushiAccounts = chushiData?.data?.items || [];
      const czn01Accounts = czn01Result.filteredAccounts || [];

      // console.log(`[CZN] Chushi returned ${chushiAccounts.length} accounts`);
      // console.log(`[CZN] CZN01 returned ${czn01Accounts.length} accounts`);

      // Store CZN01 pagination state
      if (czn01Accounts.length > 0) {
        currentPage = czn01Result.lastPage;
        totalPages = czn01Result.totalPages;
        allFilteredAccounts = czn01Accounts;
      }

      // Merge and render results
      renderResults({
        chushi: { data: { items: chushiAccounts } },
        czn01: { data: czn01Accounts, hasMore: czn01Result.hasMore }
      });

      // Hide toast and show success message
      hideToast();
      const totalResults = chushiAccounts.length + czn01Accounts.length;
      if (totalResults > 0) {
        setTimeout(() => showToast(`✅ Found ${totalResults} matching account(s)!`, 3000), 300);
      } else {
        setTimeout(() => showToast('ℹ️ No matching accounts found.', 3000), 300);
      }

    } catch (err) {
      // console.error('Search failed:', err);

      // Check if it's a timeout error
      const isTimeout = err.message && err.message.includes('TIMEOUT');

      if (isTimeout) {
        resultsEl.innerHTML = '<div class="no-data">⏱️ The game server is taking too long to respond.<br><br>This usually means the server is experiencing high load or connectivity issues.<br><br>Please try again in a few moments.</div>';
        hideToast();
        setTimeout(() => showToast('⏱️ Server timeout. Please try again in a moment.', 4000), 300);
      } else {
        resultsEl.innerHTML = '<div class="no-data">❌ Search failed. Please try again.</div>';
        hideToast();
        setTimeout(() => showToast('❌ Search failed. Please try again.', 3000), 300);
      }
    } finally {
      // Re-enable search button
      const searchBtn = document.querySelector("#searchBtn");
      if (searchBtn) {
        searchBtn.disabled = false;
        searchBtn.textContent = 'Search';
      }
    }
  }

  // Render results from both APIs with priority ordering
  function renderResults(payload) {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;

    // Tag results by source and priority
    let chushiList = [], czn01List = [];

    if (payload.chushi) {
      chushiList = (payload.chushi?.data?.items || []).map(acc => ({
        ...acc,
        _source: 'chushi',
        _priority: API_SOURCES.chushi.priority
      }));
    }

    if (payload.czn01) {
      czn01List = (payload.czn01?.data || []).map(acc => ({
        ...acc,
        _source: 'czn01',
        _priority: API_SOURCES.czn01.priority
      }));
    }

    // Combine and sort by priority (lower number = higher priority = shown first)
    const list = [...chushiList, ...czn01List].sort((a, b) => a._priority - b._priority);

    // console.log('[CZN] ═══════════════════════════════════════════');
    // console.log('[CZN] RESULTS: Sorted by priority');
    // console.log(`[CZN] Total results: ${list.length} (Chushi: ${chushiList.length}, CZN01: ${czn01List.length})`);
    // console.log('[CZN] Display order:', list.map(acc => `${acc._source}(p${acc._priority})`).slice(0, 10).join(', '), list.length > 10 ? '...' : '');
    // console.log('[CZN] ═══════════════════════════════════════════');

    if (!list.length) {
      resultsEl.innerHTML = '<div class="no-data">No results found.</div>';
      return;
    }

    const hasMore = payload.czn01?.hasMore || false;
    let html = `<div class="results-header">Showing ${list.length} matching account(s)</div>`;

    list.forEach(account => {
      // Handle both Chushi and CZN01 response formats
      let items = [];
      let accountCode = '';
      let serverInfo = '';
      let totalCount = 0;

      if (account._source === 'chushi') {
        // Chushi format: { code, items: [{name, nums, img_url, ...}], description }
        items = Array.isArray(account.items) ? account.items : [];
        accountCode = account.code || 'N/A';
        // Chushi CZN accounts are all Global server
        serverInfo = 'Global | cs';
        totalCount = items.reduce((sum, item) => sum + (item.nums || 1), 0);
      } else {
        // CZN01 format: { code, role_img: [{name, img, ...}], district, user_role_number }
        items = account.role_img || [];
        accountCode = account.code || 'N/A';
        serverInfo = `${translateServer(account.district) || 'N/A'} | czn01`;
        totalCount = account.user_role_number || 0;
      }

      // Group characters by name and count duplicates
      const charCounts = {};
      const charData = {};

      items.forEach(char => {
        const name = char.name;
        if (!charCounts[name]) {
          charCounts[name] = 0;
          charData[name] = char;
        }
        charCounts[name] += (char.nums || 1);
      });

      // Create array of unique characters with counts
      const uniqueChars = Object.keys(charCounts).map(name => ({
        ...charData[name],
        count: charCounts[name]
      }));

      // Sort: Characters first, then weapons
      const sortedChars = sortCharacters(uniqueChars);
      const characterThumbs = sortedChars.map(char => {
        const displayName = translateName(char.name);
        const customImg = getCustomImage(char.name);
        const displayImg = customImg || char.img_url || char.img;
        const count = char.count || 1;

        return `<div class="char-item">
          <img src="${escapeHtml(displayImg)}" alt="${escapeHtml(displayName)}" title="${escapeHtml(displayName)}" class="char-thumb" loading="lazy"/>
          <div class="char-label">${escapeHtml(displayName)}</div>
          ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
        </div>`;
      }).join('');

      html += `
        <div class="result-card">
          <div class="result-header">
            <div class="result-id">
              <strong>Account ID:</strong> ${escapeHtml(privateToPublicID(accountCode))}
            </div>
            <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(privateToPublicID(accountCode))}')">Copy ID</button>
          </div>
          <div class="result-body">
            <div class="result-info">
              <div class="result-detail"><strong>Count:</strong> ${totalCount} total</div>
              <div class="result-detail"><strong>Server:</strong> ${escapeHtml(serverInfo)}</div>
            </div>
            <div class="character-grid">
              ${characterThumbs}
            </div>
          </div>
        </div>
      `;
    });

    // Add "Load More" button if CZN01 has more pages
    if (hasMore) {
      html += `
        <div style="text-align: center; margin: 20px 0;">
          <button id="loadMoreBtn" class="btn primary" style="padding: 12px 24px;">
            Load More Results (CZN01)
          </button>
        </div>
      `;
    }

    resultsEl.innerHTML = html;

    // Attach load more handler
    const loadMoreBtn = document.querySelector('#loadMoreBtn');
    if (loadMoreBtn) {
      loadMoreBtn.onclick = loadMoreAccounts;
    }
  }

  function renderSearchResults(data) {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;

    if (!data.data || !data.data.length) {
      resultsEl.innerHTML = '<div class="no-data">No matching accounts found.</div>';
      return;
    }

    const accounts = data.data;
    const hasMore = data.hasMore || false;

    let headerText = `Showing ${accounts.length} matching account(s)`;

    let html = `<div class="results-header">${headerText}</div>`;

    accounts.forEach(account => {
      // Get character thumbnails for this account with names (apply translations)
      // Group characters by name and count duplicates
      const roleImgs = account.role_img || [];
      const charCounts = {};
      const charData = {};

      roleImgs.forEach(char => {
        const name = char.name;
        if (!charCounts[name]) {
          charCounts[name] = 0;
          charData[name] = char;
        }
        charCounts[name]++;
      });

      // Create array of unique characters with counts
      const uniqueChars = Object.keys(charCounts).map(name => ({
        ...charData[name],
        count: charCounts[name]
      }));

      // Sort: Characters first, then weapons
      const sortedChars = sortCharacters(uniqueChars);
      const characterThumbs = sortedChars.map(char => {
        const displayName = translateName(char.name);
        const customImg = getCustomImage(char.name);
        const displayImg = customImg || char.img;
        const count = char.count || 1;

        return `<div class="char-item">
          <img src="${escapeHtml(displayImg)}" alt="${escapeHtml(displayName)}" title="${escapeHtml(displayName)}" class="char-thumb" loading="lazy"/>
          <div class="char-label">${escapeHtml(displayName)}</div>
          ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
        </div>`;
      }).join('');

      html += `
        <div class="result-card">
          <div class="result-header">
            <div class="result-id">
              <strong>Account ID:</strong> ${escapeHtml(privateToPublicID(account.code || ''))}
            </div>
            <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(privateToPublicID(account.code || ''))}')">Copy ID</button>
          </div>
          <div class="result-body">
            <div class="result-info">
              <div class="result-detail"><strong>Count:</strong> ${account.user_role_number || 0} total</div>
              <div class="result-detail"><strong>Server:</strong> ${escapeHtml(translateServer(account.district) || 'N/A')} | CZN01</div>
            </div>
            <div class="character-grid">
              ${characterThumbs}
            </div>
          </div>
        </div>
      `;
    });

    // Add "Load More" button if there are more pages to search
    if (hasMore) {
      html += `
        <div style="text-align: center; margin: 20px 0;">
          <button id="loadMoreBtn" class="btn primary" style="padding: 12px 24px;">
            Load More Results
          </button>
        </div>
      `;
    }

    resultsEl.innerHTML = html;

    // Attach load more handler
    const loadMoreBtn = document.querySelector('#loadMoreBtn');
    if (loadMoreBtn) {
      loadMoreBtn.onclick = loadMoreAccounts;
    }
  }

  async function loadMoreAccounts() {
    if (isLoadingMore) {
      return;
    }

    isLoadingMore = true;
    const loadMoreBtn = document.querySelector('#loadMoreBtn');
    if (loadMoreBtn) {
      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.disabled = true;
    }

    try {
      const selectedCodes = Object.keys(selected);
      const result = await fetchNextBatch(currentSearchParams, selectedCodes, currentSelectedServer, ACCOUNTS_PER_BATCH, true);

      if (result.filteredAccounts.length === 0) {
        if (loadMoreBtn) loadMoreBtn.parentElement.remove();
        isLoadingMore = false;
        return;
      }

      // Update state
      allFilteredAccounts.push(...result.filteredAccounts);
      currentPage = result.lastPage;
      totalPages = result.totalPages;

      // console.log(`[CZN] Loaded ${result.filteredAccounts.length} more accounts. Total displayed: ${allFilteredAccounts.length}`);

      // Remove loading indicator
      const loadingDiv = document.querySelector('#loadMoreLoading');
      if (loadingDiv) loadingDiv.remove();

      // Append new accounts to existing results
      appendAccounts(result.filteredAccounts, result.hasMore);
    } catch (err) {
      console.error('Failed to load more accounts:', err);

      // Remove loading indicator
      const loadingDiv = document.querySelector('#loadMoreLoading');
      if (loadingDiv) loadingDiv.remove();

      // Check if it's a timeout error
      const isTimeout = err.message && err.message.includes('TIMEOUT');

      if (isTimeout) {
        showToast('⏱️ Server timeout while loading more. Please try again.', 4000);
      } else {
        showToast('❌ Failed to load more accounts. Please try again.', 3000);
      }

      if (loadMoreBtn) {
        loadMoreBtn.textContent = 'Load More Results';
        loadMoreBtn.disabled = false;
      }
    }

    isLoadingMore = false;
  }

  function appendAccounts(accounts, hasMore) {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;

    // Update header
    const headerEl = resultsEl.querySelector('.results-header');
    if (headerEl) {
      let headerText = `Showing ${allFilteredAccounts.length} matching account(s)`;
      headerEl.textContent = headerText;
    }

    // Remove old load more button if exists
    const oldLoadMoreBtn = resultsEl.querySelector('#loadMoreBtn');
    if (oldLoadMoreBtn) {
      oldLoadMoreBtn.parentElement.remove();
    }

    // Append new account cards
    let html = '';
    accounts.forEach(account => {
      // Group characters by name and count duplicates
      const roleImgs = account.role_img || [];
      const charCounts = {};
      const charData = {};

      roleImgs.forEach(char => {
        const name = char.name;
        if (!charCounts[name]) {
          charCounts[name] = 0;
          charData[name] = char;
        }
        charCounts[name]++;
      });

      // Create array of unique characters with counts
      const uniqueChars = Object.keys(charCounts).map(name => ({
        ...charData[name],
        count: charCounts[name]
      }));

      // Sort: Characters first, then weapons
      const sortedChars = sortCharacters(uniqueChars);
      const characterThumbs = sortedChars.map(char => {
        const displayName = translateName(char.name);
        const customImg = getCustomImage(char.name);
        const displayImg = customImg || char.img;
        const count = char.count || 1;

        return `<div class="char-item">
          <img src="${escapeHtml(displayImg)}" alt="${escapeHtml(displayName)}" title="${escapeHtml(displayName)}" class="char-thumb" loading="lazy"/>
          <div class="char-label">${escapeHtml(displayName)}</div>
          ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
        </div>`;
      }).join('');

      html += `
        <div class="result-card">
          <div class="result-header">
            <div class="result-id">
              <strong>Account ID:</strong> ${escapeHtml(privateToPublicID(account.code || ''))}
            </div>
            <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(privateToPublicID(account.code || ''))}')">Copy ID</button>
          </div>
          <div class="result-body">
            <div class="result-info">
              <div class="result-detail"><strong>Count:</strong> ${account.user_role_number || 0} total</div>
              <div class="result-detail"><strong>Server:</strong> ${escapeHtml(translateServer(account.district) || 'N/A')} | CZN01</div>
            </div>
            <div class="character-grid">
              ${characterThumbs}
            </div>
          </div>
        </div>
      `;
    });

    // Add new load more button if there are more pages to search
    if (hasMore) {
      html += `
        <div style="text-align: center; margin: 20px 0;">
          <button id="loadMoreBtn" class="btn primary" style="padding: 12px 24px;">
            Load More Results
          </button>
        </div>
      `;
    }

    resultsEl.insertAdjacentHTML('beforeend', html);

    // Reattach load more handler
    const newLoadMoreBtn = document.querySelector('#loadMoreBtn');
    if (newLoadMoreBtn) {
      newLoadMoreBtn.onclick = loadMoreAccounts;
    }
  }

  document.querySelector("#clearBtn")?.addEventListener('click', clearSelection);
  document.querySelector("#searchBtn")?.addEventListener('click', performSearch);
  window.copyToClipboard = copyToClipboard;
  loadResources();
})();
